import React from 'react';
import { useId } from '@fluentui/react-hooks';
import {
  Label, mergeClasses, Select, SelectProps,
} from '@fluentui/react-components';
import { useDataSource } from '@bingads-webui-react/data-source';

import { I18n } from '../types';
import { usePageSizeSelectorStyles } from './page-size-selector-styles';

interface PageSizeSelectorProps {
  i18n: I18n;
  pageSizeOptions: number[];
  onPageSizeChange?: (val) => void
}

export const InternalPageSizeSelector = (
  {
    i18n, onPageSizeChange, className, pageSizeOptions, ...props
  }: (PageSizeSelectorProps & SelectProps),
) => {
  const selectId = useId();
  const classes = usePageSizeSelectorStyles();
  const { goToPage, pageSize, setPageSize } = useDataSource();

  const onChangeInternal = (_ev, data) => {
    const pageSizeVal = parseInt(data.value, 10);
    if (onPageSizeChange) {
      onPageSizeChange(pageSizeVal);
    }
    goToPage(1);
    setPageSize(pageSizeVal);
  };

  return (
    <div className={mergeClasses('page-selector', classes.root, className)}>
      <Label htmlFor={selectId}>{i18n.getString(_TL_('Rows per page:'))}</Label>
      <Select
        id={selectId}
        onChange={onChangeInternal}
        value={pageSize}
        {...props}
      >
        {
          pageSizeOptions.map((pageSizeOption) => <option key={pageSizeOption}>{pageSizeOption}</option>)
        }
      </Select>
    </div>
  );
};

export const PageSizeSelector = React.forwardRef(InternalPageSizeSelector);
